import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import isEqual from 'lodash-es/isEqual'
import InfiniteScroll from 'react-infinite-scroll-component'
import { BuyWithMoonPay, Button, Tooltip } from '@binance-chain/honeycomb'
import { em } from 'polished'

import { setFingerPrint } from 'utils/fingerPrint'
import { TOKEN_TYPE_BEP2, TOKEN_TYPE_BEP8 } from 'utils/tokenTypes'
import { EXPLORER_URL } from 'utils/httpRequest'
import StakingModal from 'containers/staking/index'
import { Consumer as BNCClientConsumer } from '../context/BNCClientProvider'
import { Consumer as WallectClientConsumer } from '../context/WalletConnectProvider'
import LedgerModalHost from '../modals/LedgerModalHost'
import TrezorModalHost from '../modals/TrezorModalHost'
import CoinomiModalHost from '../modals/CoinomiModalHost'
import InfinitoModalHost from '../modals/InfinitoModalHost'
import WalletConnectModal from '../modals/WalletConnectModal'

import Header from '../header'

import Layout from '../../components/common/Layout'
import message from '../../components/common/Message'
import Icon from '../../components/common/Icon'
import FontNumber from '../../components/common/FontNumber'
import QRCode from '../../components/common/QRCode'
import CheckBox from '../../components/common/CheckBox'
import OrderTable from '../../components/order/OrderTable'
import SendModal from '../../components/balances/Send'
import {
  GlobalStyle,
  MobileWrap,
  MobileContent,
  MobileTitle,
  DesktopWrap,
} from '../../components/mobile'

import { Content } from '../order/orderHistory'
import { FilterButton } from '../order/openOrders'

import { formatNumber, decimalPlaces, roundValue } from '../../utils/number'
import hasPrivateKey, { isUnlockWithWalletConnect } from '../../utils/account'
import getUrlParams, { isMobile } from '../../utils/bomUtils'
import { withI18n } from '../../i18n/util'

import { getCurrency } from '../../redux/exchange/action'
import { setTriggerElement } from '../../redux/global/action'
import { getPairs } from '../../redux/tradePairs/action'
import { getAccount, setNeedAuth } from '../../redux/account/action'
import { setWalletConnectURI } from '../../redux/walletConnect/action'
import { getSymbolTickers } from '../../redux/tickers/action'
import FlexBox from '../../components/common/FlexBox'
import BalanceItem from '../../components/mobile/BalanceItem'
import { DexThemeProvider } from '../../components/common/DexThemeProvider'
import ExtensionWalletProvider from '../../components/ExtensionWalletProvider'
import { BinanceWalletModalHost } from '../modals/BinanceWalletModalHost'

const PAGE_SIZE = 25

const Wrapper = styled.div`
  background: #fdfdfd;
  display: flex;
  justify-content: center;
`

const Title = styled.div`
  color: #212833;
  font-size: 20px;
  margin-bottom: 10px;
  background: #fff;
  display: flex;
  justify-content: flex-start;

  .text-address {
    font-size: 14px;
    margin-left: 20px;
    color: #848e9c;
    i {
      margin-left: 5px;
    }
  }
`

const TitleText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const FilterWrap = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #fff;
  box-shadow: 0px 1px 20px 0px rgba(90, 102, 124, 0.08);
  height: 40px;
  padding: 0 5px 0 15px;
`

const CellItem = styled.div`
  color: #212833;
  white-space: nowrap;
  display: flex;
  align-items: center;
`

const AssetInput = styled.div`
  display: flex;
  border-bottom: 1px solid #dfe2e7;
  margin-right: 20px;
  input {
    outline: none;
    border: none;
    margin-left: 5px;
  }
`

const EstimatedValue = styled.div`
  color: #212833;
  flex-grow: 2;
  text-align: right;
  i {
    font-size: 13px;
  }

  span {
    font-size: 14px;
  }
`

const Total = styled.div`
  font-size: 25px;
  color: #fff;
  font-weight: 500;
  margin-right: 50px;
`

const MobileEstimateContent = styled.div`
  background: linear-gradient(225deg, rgba(29, 36, 46, 1) 0%, rgba(19, 23, 30, 1) 100%);
  box-shadow: 0px 0px 8px 0px rgba(11, 14, 17, 0.5);
  border-radius: 3px;
  color: #848e9c;
  padding: 25px 12px;
  .totalUsd {
    font-size: 14px;
  }
  .address {
    color: #848e9c;
    font-size: 17px;
    font-weight: 500;
    width: 240px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 22px;
  }
`

const Box = styled.div`
  width: 24px;
  height: 24px;
  background: rgba(33, 40, 51, 1);
  border-radius: 1px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const BalanceList = styled.div`
  position: relative;
  padding: 20px 0;
  margin-top: 20px;
  border-top: 1px solid #000;
  .hideWrap {
    padding: 12px 0;
  }
`

const MobileQrCode = styled(FlexBox)`
  justify-content: center;
  margin-top: 20px;
  .qrcode-box {
    border: none;
  }
`
const AddressButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 16px;
`

const AddressButtonsItem = styled.div`
  flex: 1;
  margin-left: ${({ theme }) => em(theme.honeycomb.size.small)};
  display: flex;
  align-items: center;
  justify-content: center;
`

const SendButton = styled(FilterButton)`
  color: #f0b90b;
  border-color: #f0b90b;
  &:hover {
    background: #f0b90b;
    color: #fff;
  }
`

const DepositWithdrawItem = styled(CellItem)`
  display: flex;
  justify-content: flex-end;
  padding-right: 10px;
`

const Space = styled.div`
  flex: 1;
`

const BuyButtonWrapper = styled.div`
  font-size: 16px;
  display: flex;
  flex: 0 0 180px;
  white-space: nowrap;

  > a {
    flex: 1 0 auto;

    > svg {
      &:nth-of-type(1) {
        font-size: 3em;
      }

      &:nth-of-type(2) {
        font-size: 2em;
      }
    }
  }
`

const TokenTypeLabel = styled.div`
  width: 40px;
  height: 16px;
  line-height: 16px;
  background: #fef6d8;
  border-radius: 8px;
  margin-left: 8px;
  color: #d0980b;
  font-weight: 500;
  font-size: 12px;
`

const DipalyedAssetName = styled.a`
  color: #1e2026;
  font-size: 14px;
  line-height: 16px;
  &:hover {
    color: #d0980b;
  }
`

export const getLastPrice = (symbolTickers, pairs, baseAsset, quoteAsset = 'BNB') => {
  const ticker = symbolTickers.find(st => st.symbol === `${baseAsset}_${quoteAsset}`)
  const pair = pairs.find(
    p => p.base_asset_symbol === baseAsset && p.quote_asset_symbol === quoteAsset
  )
  let lastPrice
  if (ticker) {
    lastPrice = parseFloat(ticker.price || 0)
  } else if (pair) {
    lastPrice = parseFloat(pair.price || 0, 10)
  } else {
    const quoteTicker = symbolTickers.find(st => st.symbol === `${quoteAsset}_${baseAsset}`)
    if (quoteTicker) {
      lastPrice = quoteTicker.price > 0 ? 1 / parseFloat(quoteTicker.price, 10) : 0
    } else {
      const quotePair =
        pairs.find(p => p.base_asset_symbol === quoteAsset && p.quote_asset_symbol === baseAsset) ||
        {}
      lastPrice = quotePair.price > 0 ? 1 / parseFloat(quotePair.price, 10) : 0
    }
  }

  return lastPrice
}

class Balances extends PureComponent {
  static propTypes = {
    userInfo: PropTypes.object,
    tokens: PropTypes.array,
    symbolTickers: PropTypes.array,
    pairs: PropTypes.array,
    privateKey: PropTypes.string,
    dispatch: PropTypes.func,
    cryptoCurrencyRate: PropTypes.object,
    history: PropTypes.object,
    formatI18nText: PropTypes.func,
    fees: PropTypes.array,
    deviceInfo: PropTypes.object.isRequired,
    address: PropTypes.string,
    locale: PropTypes.string.isRequired,
  }

  static defaultProps = {
    tokens: [],
    symbolTickers: [],
    pairs: [],
    fees: [],
    userInfo: {},
    privateKey: '',
    dispatch: () => {},
    cryptoCurrencyRate: {},
    history: {},
    formatI18nText: () => {},
    address: '',
  }

  constructor(props) {
    super(props)
    this.state = {
      filterAsset: '',
      filterAssets: [],
      showSend: false,
      hideZeroBalance: true,
      showMobileCode: false,
      sendingAsset: null,
      page: 0,
      isShowStakingModal: false,
    }
  }

  componentDidMount() {
    const { dispatch } = this.props

    this._getBalances()
    dispatch(getCurrency())
    dispatch(getSymbolTickers())
    dispatch(getPairs())
    const { filterAsset, hideZeroBalance } = this.state
    this._getFilterdAssets(filterAsset, hideZeroBalance)
  }

  componentDidUpdate(prevProps) {
    const { userInfo, tokens } = this.props
    const { filterAsset, hideZeroBalance } = this.state
    if (!isEqual(prevProps.userInfo, userInfo) || !isEqual(prevProps.tokens, tokens)) {
      this._getFilterdAssets(filterAsset, hideZeroBalance)
    }
  }

  _getFilterdAssets = (asset = '', hideZeroBalance) => {
    const balances = this._buildBalances()
    asset = asset.toUpperCase()
    const isShowStakingModal = getUrlParams('staking')
    this.setState({
      page: 0,
      hideZeroBalance,
      filterAsset: asset,
      filterAssets: balances.filter(b => {
        const name = (b.name && b.name.toUpperCase()) || ''
        const ass = (b.displayName && b.displayName.toUpperCase()) || ''
        const isNameExist = name.includes(asset) || ass.replace(/\.B/, '').includes(asset)
        const balance = parseFloat(b.totalBalance)
        return hideZeroBalance ? balance > 0 && isNameExist : isNameExist
      }),
      isShowStakingModal,
    })
  }

  _buildColumns = wcClient => {
    const { formatI18nText } = this.props
    const columns = [
      {
        title: formatI18nText('exchange.asset'),
        headerAlign: 'left',
        dataIndex: 'asset',
        key: 'Asset',
        width: '15%',
        render: item => (
          <CellItem>
            <DipalyedAssetName href={`${EXPLORER_URL}/asset/${item.asset}`}>
              {item.displayName}
            </DipalyedAssetName>
            {item.tokenType === TOKEN_TYPE_BEP8 && <TokenTypeLabel>Mini</TokenTypeLabel>}
          </CellItem>
        ),
      },
      {
        title: formatI18nText('exchange.name'),
        dataIndex: 'name',
        headerAlign: 'left',
        key: 'Name',
        width: '15%',
        render: item => <CellItem>{item.name}</CellItem>,
      },
      {
        title: formatI18nText('exchange.totalBalance'),
        dataIndex: 'totalBalance',
        key: 'Total Balance',
        width: '15%',
        render: item => (
          <CellItem>
            <FontNumber
              value={formatNumber(item.totalBalance, decimalPlaces(item.totalBalance), 3)}
            />
          </CellItem>
        ),
      },
      {
        title: formatI18nText('exchange.availableBalance'),
        dataIndex: 'availableBalance',
        key: 'Available Balance',
        width: '15%',
        render: item => (
          <CellItem>
            <FontNumber
              value={formatNumber(item.availableBalance, decimalPlaces(item.availableBalance), 3)}
            />
          </CellItem>
        ),
      },
      {
        title: formatI18nText('exchange.frozen'),
        dataIndex: 'frozen',
        key: 'Frozen',
        width: '10%',
        render: item => (
          <CellItem>
            <FontNumber value={formatNumber(item.frozen, decimalPlaces(item.frozen), 3)} />
          </CellItem>
        ),
      },
      {
        title: formatI18nText('exchange.inOrder'),
        dataIndex: 'inOrder',
        key: 'In Order',
        width: '10%',
        render: item => (
          <CellItem>
            <FontNumber value={formatNumber(item.inOrder, decimalPlaces(item.inOrder), 3)} />
          </CellItem>
        ),
      },
      {
        title: formatI18nText('exchange.BTCValue'),
        dataIndex: 'BTCValue',
        key: 'BTCValue',
        width: '10%',
        render: item => (
          <CellItem>
            <FontNumber value={formatNumber(item.BTCValue, decimalPlaces(item.BTCValue), 3)} />
          </CellItem>
        ),
      },
      {
        title: '',
        dataIndex: 'op',
        headerAlign: 'right',
        key: 'op',
        width: '10%',
        render: item => (
          <DepositWithdrawItem>
            <SendButton
              onClick={ev => {
                console.log(ev)
                this._showSend(ev, item, wcClient)
              }}
            >
              Send
            </SendButton>
          </DepositWithdrawItem>
        ),
      },
    ]
    return columns
  }

  _buildBalances = () => {
    const { tokens, userInfo, symbolTickers, pairs, cryptoCurrencyRate } = this.props

    const balances = userInfo.balances || []

    const result = tokens.map(token => {
      const { symbol } = token
      const balance = balances.find(item => token.symbol === item.symbol)

      let availableBalance = 0
      let inOrder = 0
      let frozen = 0
      if (balance) {
        availableBalance = parseFloat(balance.free, 10)
        inOrder = parseFloat(balance.locked, 10)
        frozen = parseFloat(balance.frozen, 10)
        availableBalance = Number.isNaN(availableBalance) ? 0 : availableBalance
        inOrder = Number.isNaN(inOrder) ? 0 : inOrder
        frozen = Number.isNaN(frozen) ? 0 : frozen
      }

      const totalBalance = availableBalance + inOrder + frozen

      let bnbBtcPair = symbolTickers.find(st => st.symbol.includes('BNB_BTC'))
      if (!bnbBtcPair) {
        bnbBtcPair =
          pairs.find(p => p.base_asset_symbol === 'BNB' && p.quote_asset_symbol.includes('BTC')) ||
          {}
      }

      const lastPrice = symbol === 'BNB' ? 1 : getLastPrice(symbolTickers, pairs, symbol)

      const bnbValue = symbol === 'BNB' ? totalBalance : lastPrice * totalBalance

      let btcValue = symbol.includes('BTC')
        ? totalBalance
        : bnbValue * parseFloat(bnbBtcPair.price || 0, 10)
      btcValue = roundValue(btcValue)

      let usdtValue
      if (btcValue === 0 && bnbValue > 0) {
        usdtValue = cryptoCurrencyRate.BNB_USDT ? bnbValue * cryptoCurrencyRate.BNB_USDT : ''
      } else {
        usdtValue = cryptoCurrencyRate.BTC_USDT ? btcValue * cryptoCurrencyRate.BTC_USDT : ''
      }

      return {
        asset: symbol,
        name: token.name,
        displayName: token.original_symbol,
        totalBalance: totalBalance < 0.000001 ? totalBalance.toFixed(8) : totalBalance,
        availableBalance:
          availableBalance < 0.000001 ? availableBalance.toFixed(8) : availableBalance,
        frozen: frozen < 0.000001 ? frozen.toFixed(8) : frozen,
        inOrder: inOrder < 0.000001 ? inOrder.toFixed(8) : inOrder,
        BTCValue: btcValue,
        tokenType: /.+-[A-Za-z\d]{3}m/i.test(symbol) ? TOKEN_TYPE_BEP8 : TOKEN_TYPE_BEP2,
        bnbValue,
        usdtValue,
        op: 'op',
      }
    })

    return result.sort((a, b) => a.asset.localeCompare(b.asset))
  }

  _assetChange = e => {
    const asset = e.currentTarget.value.trim()
    const { hideZeroBalance } = this.state
    this._getFilterdAssets(asset, hideZeroBalance)
  }

  _getBalances = () => {
    const { dispatch } = this.props
    let user = sessionStorage.getItem('user')
    user = (user && JSON.parse(user)) || {}
    const { address } = user
    dispatch(getAccount(address))
  }

  _handleCheckChange = e => {
    const {
      target: { checked },
    } = e
    const { filterAsset } = this.state
    this._getFilterdAssets(filterAsset, checked)
  }

  _showSend = async (ev, item, wcClient) => {
    const { privateKey, dispatch, history, locale } = this.props
    if (!hasPrivateKey()) {
      history.push(`/${locale}/unlock`)
      return
    }

    if (isUnlockWithWalletConnect() && !wcClient.connected()) {
      const uri = await wcClient.startSession(false)
      console.log('WalletConnect URI', uri)
      dispatch(setWalletConnectURI(uri))
      dispatch(setTriggerElement(ev.currentTarget))
      return
    }

    if (!privateKey) {
      dispatch(setTriggerElement(ev.currentTarget))
      dispatch(setNeedAuth(true))
      return
    }

    if (!isMobile()) {
      this.setState({ showSend: true, sendingAsset: item })
    } else {
      // eslint-disable-next-line consistent-return
      return true
    }
  }

  _copyAddress = () => {
    const { address } = this._getUserInfo()

    try {
      navigator.clipboard.writeText(address)
      this._copyAddressSuccess()
    } catch (e) {
      console.log(e.message)
    }
  }

  _copyAddressSuccess = () => {
    const { formatI18nText } = this.props
    message.info(formatI18nText('header.user.copySuccess'))
  }

  _showMobileQrCode = () => {
    const { showMobileCode } = this.state
    this.setState({ showMobileCode: !showMobileCode })
  }

  _paging = page => {
    this.setState({ page: page - 1 })
  }

  _fetchMore = () => {
    const { page } = this.state
    this.setState({ page: page + 1 })
  }

  _closeSendModal = () => {
    this.setState({ showSend: false }, () => {
      this._getBalances()
    })
  }

  _getUserInfo = () => {
    const userInfo = sessionStorage.getItem('user')
    return (userInfo && JSON.parse(userInfo)) || {}
  }

  _trackData = () => {
    const { deviceInfo, address } = this.props
    setFingerPrint(deviceInfo, 'transfer_moon_pay', address, '')
  }

  _closeStakingModal = () => {
    this.setState({ isShowStakingModal: false })
  }

  render() {
    const {
      filterAssets,
      showSend,
      sendingAsset,
      showMobileCode,
      hideZeroBalance,
      page,
      isShowStakingModal,
    } = this.state
    const { privateKey, address, formatI18nText } = this.props
    const userInfo = this._getUserInfo()
    const balances = this._buildBalances()
    const { cryptoCurrencyRate } = this.props
    let totalBnbValue = balances.reduce((n, pre) => n + parseFloat(pre.bnbValue, 10), 0)

    let totalBTCValue = balances.reduce((n, pre) => n + parseFloat(pre.BTCValue, 10), 0)

    totalBTCValue = roundValue(totalBTCValue)
    totalBnbValue = roundValue(totalBnbValue)

    let totalUsd = balances.reduce((n, pre) => n + parseFloat(pre.usdtValue, 10), 0)

    if (cryptoCurrencyRate) {
      totalUsd = window.Intl
        ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(totalUsd)
        : `$${formatNumber(totalUsd)}`
    }

    const dataSource = filterAssets.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE)

    const mobileDataSource = filterAssets.slice(0, (page + 1) * PAGE_SIZE)

    return (
      <DexThemeProvider theme="light">
        <WallectClientConsumer>
          {wcClient => (
            <BNCClientConsumer>
              {bncClient => (
                <Fragment>
                  <DesktopWrap>
                    <DexThemeProvider theme="light">
                      <Layout>
                        <Wrapper>
                          <Content>
                            <Title>
                              <TitleText>
                                <span>{formatI18nText('header.balances')}</span>
                                <span className="text-address">
                                  <i>{userInfo.address}</i>
                                </span>
                              </TitleText>
                              <AddressButtonsContainer>
                                <AddressButtonsItem>
                                  <Tooltip
                                    content={
                                      <QRCode value={userInfo.address} size={174} padding={10} />
                                    }
                                  >
                                    <Button variant="secondary" size="increased" shape="square">
                                      <Icon type="qrcode" size="14" />
                                    </Button>
                                  </Tooltip>
                                </AddressButtonsItem>
                                <AddressButtonsItem>
                                  <Button
                                    variant="secondary"
                                    size="increased"
                                    shape="square"
                                    onClick={this._copyAddress}
                                  >
                                    <Icon type="copy" size="14" />
                                  </Button>
                                </AddressButtonsItem>
                              </AddressButtonsContainer>
                              <>
                                <Space />
                                <BuyButtonWrapper onClick={this._trackData}>
                                  <BuyWithMoonPay shape="fit" address={userInfo.address}>
                                    {formatI18nText('common.buy-crypto-on-ramp')}
                                  </BuyWithMoonPay>
                                </BuyButtonWrapper>
                              </>
                            </Title>
                            <FilterWrap>
                              <AssetInput>
                                <Icon type="search" />
                                <input
                                  type="text"
                                  placeholder={formatI18nText('balances.filteredByAsset')}
                                  onChange={this._assetChange}
                                />
                              </AssetInput>

                              <CheckBox
                                labelTitle={formatI18nText('balances.hideZeroBalance')}
                                defaultChecked={hideZeroBalance}
                                handleCheckChange={this._handleCheckChange}
                              />

                              <EstimatedValue>
                                <i>{formatI18nText('exchange.estimatedValue')}: </i>
                                <span>
                                  {totalBTCValue === 0 ? (
                                    <>
                                      <FontNumber
                                        value={formatNumber(
                                          totalBnbValue,
                                          decimalPlaces(totalBnbValue)
                                        )}
                                      />
                                      BNB /&nbsp;
                                    </>
                                  ) : (
                                    <>
                                      <FontNumber
                                        value={formatNumber(
                                          totalBTCValue,
                                          decimalPlaces(totalBTCValue)
                                        )}
                                      />
                                      BTC /&nbsp;
                                    </>
                                  )}
                                  <FontNumber value={totalUsd} />
                                </span>
                              </EstimatedValue>
                            </FilterWrap>
                            <OrderTable
                              columns={this._buildColumns(wcClient)}
                              dataSource={dataSource}
                              paging={this._paging}
                              total={filterAssets.length}
                            />
                          </Content>

                          {showSend && (
                            <SendModal
                              bncClient={bncClient}
                              assets={this._buildBalances()}
                              privateKey={privateKey}
                              sendingAsset={sendingAsset}
                              address={userInfo.address}
                              account_number={userInfo.account_number}
                              sequence={parseInt(userInfo.sequence, 10)}
                              close={this._closeSendModal}
                            />
                          )}
                          {/* Modal providers */}
                          <LedgerModalHost showConfirmAddress={true} />
                          <TrezorModalHost />
                          <CoinomiModalHost />
                          <InfinitoModalHost />
                          <WalletConnectModal />
                        </Wrapper>
                      </Layout>
                    </DexThemeProvider>
                  </DesktopWrap>

                  {isMobile() && (
                    <MobileWrap>
                      <DexThemeProvider theme="dark">
                        <Fragment>
                          <Header />
                          <MobileContent>
                            <MobileTitle style={{ textIndent: '10px', fontWeight: 'bold' }}>
                              {formatI18nText('balances.myBalances')}
                            </MobileTitle>
                            <MobileEstimateContent>
                              <div>{formatI18nText('exchange.estimatedValue')}: </div>
                              <FlexBox align="center">
                                <Total>
                                  <FontNumber
                                    value={formatNumber(
                                      totalBTCValue,
                                      decimalPlaces(totalBTCValue)
                                    )}
                                  />
                                  BTC
                                </Total>
                                <span className="totalUsd">
                                  <FontNumber value={totalUsd} />
                                </span>
                              </FlexBox>
                              <FlexBox margin="10px 0 0 0" justify="space-between" align="center">
                                <div className="address">{address}</div>
                                <CopyToClipboard
                                  text={userInfo.address}
                                  onCopy={this._copyAddressSuccess}
                                >
                                  <Box onClick={this._copyAddressSuccess}>
                                    <Icon type="copy" size="14" />
                                  </Box>
                                </CopyToClipboard>
                                <Box onClick={this._showMobileQrCode}>
                                  <Icon type={showMobileCode ? 'close' : 'qrcode'} size="14" />
                                </Box>
                              </FlexBox>
                              {showMobileCode && (
                                <MobileQrCode>
                                  <QRCode value={address} size={174} padding={10} />
                                </MobileQrCode>
                              )}
                            </MobileEstimateContent>
                            <BalanceList>
                              <div className="hideWrap">
                                <CheckBox
                                  labelTitle="Hide Zero Balance"
                                  defaultChecked={hideZeroBalance}
                                  handleCheckChange={this._handleCheckChange}
                                />
                              </div>
                              <InfiniteScroll
                                dataLength={mobileDataSource.length}
                                next={this._fetchMore}
                                hasMore={filterAssets.length > mobileDataSource.length}
                                loader={<h4>...</h4>}
                              >
                                {mobileDataSource.map(item => (
                                  <BalanceItem
                                    key={item.asset}
                                    balance={item}
                                    send={ev => {
                                      return this._showSend(ev, item, wcClient)
                                    }}
                                  />
                                ))}
                              </InfiniteScroll>
                            </BalanceList>
                          </MobileContent>
                          <WalletConnectModal />
                        </Fragment>
                      </DexThemeProvider>
                      <GlobalStyle />
                    </MobileWrap>
                  )}
                </Fragment>
              )}
            </BNCClientConsumer>
          )}
        </WallectClientConsumer>
        <StakingModal isOpen={isShowStakingModal} onClose={this._closeStakingModal} />
        <ExtensionWalletProvider />
        <BinanceWalletModalHost />
      </DexThemeProvider>
    )
  }
}

const mapStateToProps = ({
  exchange: { tokens, cryptoCurrencyRate },
  tradePairs: { pairs },
  tickers: { symbolTickers },
  account: { userInfo, privateKey, address },
  globalData: { deviceInfo },
}) => ({
  userInfo,
  tokens,
  privateKey,
  cryptoCurrencyRate,
  symbolTickers,
  pairs,
  address,
  deviceInfo,
})

export default withI18n(connect(mapStateToProps)(withRouter(Balances)))
